// extracted by mini-css-extract-plugin
module.exports = {"shareItem":"ShareViaSocialNetworkButtons_shareItem__ATawt","shareContainer":"ShareViaSocialNetworkButtons_shareContainer__3oksC"};